module.exports = __webpack_public_path__ + "static/media/organize.80ff3f6d.svg";